import React from 'react'

export default function ChartRecommendationPanel({
  recommendations,
  charts,
  onSelectChart,
}) {
  if (!recommendations || recommendations.length === 0) return null

  function getChartName(chartId) {
    const match = (charts || []).find((chart) => chart.metadata.id === chartId)
    return match ? match.metadata.name : chartId
  }

  function getChart(chartId) {
    return (charts || []).find((chart) => chart.metadata.id === chartId)
  }

  return (
    <div className="mb-3">
      <h5>Chart Recommendations</h5>
      <ul className="list-unstyled">
        {recommendations.map((recommendation, index) => {
          const chart = getChart(recommendation.chartKey)

          return (
            <li key={index} className="mb-1">
              <button
                className="btn btn-sm btn-outline-primary mr-2"
                disabled={!chart}
                onClick={() => chart && onSelectChart(chart)}
              >
                {getChartName(recommendation.chartKey)}
              </button>
              <span className="text-muted small">{recommendation.reason}</span>
              {recommendation.suggestedMapping &&
                Object.keys(recommendation.suggestedMapping).length > 0 && (
                  <div className="small text-muted mt-1">
                    Recommended mapping:{' '}
                    {Object.entries(recommendation.suggestedMapping)
                      .filter(
                        ([, columns]) =>
                          Array.isArray(columns) && columns.length > 0
                      )
                      .map(
                        ([dimension, columns]) =>
                          `${dimension} -> ${columns.join(', ')}`
                      )
                      .join(' · ')}
                  </div>
                )}
              {recommendation.optionHints &&
                recommendation.optionHints.length > 0 && (
                  <div className="small text-muted mt-1">
                    Next in Customize: {recommendation.optionHints[0]}
                  </div>
                )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
